import React from 'react'
import PropTypes from 'prop-types'
import { Table as BsTable, Button } from 'react-bootstrap'
import { useModal } from '@ExcelFilterRules/hooks/useModal'
import { Modal } from '@ExcelFilterRules/components/Table/Modal'
import { capitalizeFirstLetter } from '@ExcelFilterRules/utils'

export function Table({ data }) {
  const { modalState, modalData, toggleModal } = useModal()

  const tableData =
    Array.isArray(data) &&
    data.map((student, idx) => {
      const key = `${student.user_info.pk}${idx}`
      return (
        <tr key={key}>
          <td>{student.user_info.first_name}</td>
          <td>{student.user_info.last_name}</td>
          <td>{student.user_info.email}</td>
          <td>{generateBadges(student.severity_count)}</td>
          <td>
            <Button
              className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
              onClick={() => toggleModal(student)}
            >Details</Button>
          </td>
        </tr>
      )
    })

  function generateBadges(data) {
    return (
      <React.Fragment>
        {data.map(arr => {
          arr.name = capitalizeFirstLetter(arr.name)
          return (
            <span
              key={arr.name}
              className={`me-badge-tint me-badge-tint-${
                arr.bootstrap || 'neutral'
              } mx-3`}
            >
              {arr.count} {arr.name}
            </span>
          )
        })}
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <Modal data={modalData} show={modalState} toggleModal={toggleModal} />
      <BsTable className="mt-4 bg-white  table-bordered table-hover ">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Violations</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>{Array.isArray(tableData) && tableData}</tbody>
      </BsTable>
    </React.Fragment>
  )
}

Table.propTypes = {
  data: PropTypes.array.isRequired,
}
